import React from "react";
import {
  Redirect,
  Route,
  withRouter,
  RouteComponentProps
} from "react-router-dom";
// import { getCookie } from "../constant/common";
import { connect } from "react-redux";
import {
  addCurrentPath,
  updateCurrentPath,
  deleteCurrentPath
} from "../stateManager/store/route/actions";
import {
  logout
} from "../stateManager/store/common/action";
import { IRouteAll } from "../stateManager/store/route/types";
import { PathsENUM } from "../constant/paths";
import { redirectOnLogin} from "./util";
import { decode } from "jsonwebtoken";
import { Http } from "./axois";
import { saveDetails, setUser } from "../stateManager/store/user/actions";
import {updateAppBranch, updateAppsList, updateAppVersion } from "../stateManager/store/apps/actions";
import _ from "lodash";
import { setCurrentOrganization } from "../stateManager/store/orgs/actions";

interface ReactInstance extends RouteComponentProps {
  exact?: boolean;
  path?: string;
  component?: any;
  addCurrentPath: (data: IRouteAll) => void;
  updateCurrentPath: (data: IRouteAll) => void;
  deleteCurrentPath: (data?: IRouteAll) => void;
  logout: () => void
  setUser: (data: any) => void
  saveDetails: (data: any) => void
  updateAppBranch: (data: any) => void
  updateAppVersion: (data: any) => void
  setCurrentOrganization: (data: any) => void
  updateAppsList: (data: any) => void
  selectedOrg: any
}

interface IState {
  xForgeToken: string;
  isAuthenticating: boolean;
  authError: boolean;
}

class AuthRoute extends React.Component<ReactInstance, IState> {
  constructor(props: ReactInstance, state: IState) {
    super(props, state);
    const urlXForgeToken = new URLSearchParams(props.location.search).get("x-forge-token");
    this.state = { 
      xForgeToken: urlXForgeToken || '',
      isAuthenticating: !!urlXForgeToken,
      authError: false
    };
  }

  async componentDidMount() {
    const xForgeToken = new URLSearchParams(this.props.location.search).get("x-forge-token");
    
    if (xForgeToken) {
      this.setState({ 
        xForgeToken,
        isAuthenticating: true,
        authError: false
      });
      
      Http.post("x-forge-auth", { token: xForgeToken }).subscribe(
        (res: any) => {
          let { firstName, email, lastName, userName, orgId, orgName, ownerId } = res;
          const decoded = decode(res.token);
          this.props.setUser({ user: decoded });
          localStorage.setItem("studioToken", res.token);
          localStorage.setItem("studioRefreshToken", res.refreshToken);
          this.props.saveDetails({
            firstName, 
            email,
            lastName: lastName,
            userName: userName,
            capabilities: res.capabilities,
          });
          
          this.setState({
            xForgeToken: '',
            isAuthenticating: false,
            authError: false
          });
          
          // Redirect to /apps after successful authentication
          this.handleJourneyPath(orgId, orgName, ownerId);
        },
        (err: any) => {
          console.error('x-forge-auth failed:', err);
          this.setState({
            xForgeToken: '',
            isAuthenticating: false,
            authError: true
          });
          
          // Redirect to signin on authentication failure
          this.props.history.push('/signin');
        }
      );
      return;
    }

    updatePath(this.props.location, this.props);

    // if request is from "genai", verify token and redirect
    const token = localStorage.getItem("studioToken");
    const redirectTo = new URLSearchParams(this.props.location.search).get("redirectTo")
    if(redirectTo && token && window.env.GENAI_URL && redirectTo === window.env.GENAI_URL) {
      sessionStorage.setItem('redirectTo', redirectTo)

      // if token is expired, logout and show signin page
      const payload = decode(token) as any
      const currentTime = Math.floor(Date.now() / 1000);
      if (currentTime > payload?.exp) {
        this.props.logout()
        localStorage.clear();
        this.props.history.push('/signin');
        return
      }

      redirectOnLogin(token)
      return
    }

    this.props.history.listen((location, action) => {
      updatePath(location, this.props);
    });
  }

  shouldComponentUpdate(nextProps: ReactInstance, nextState: any) {
    return nextProps.location.pathname === this.props.location.pathname &&
           nextState.isAuthenticating === this.state.isAuthenticating &&
           nextState.authError === this.state.authError
      ? false
      : true;
  }

  async handleJourneyPath(orgId: string, orgName: string, ownerId: string) {
    const { pathname } = this.props.location;
    const isJourneyAssist = pathname.includes("/journey/assist");
    const isJourneySolo = pathname.includes("/journey/solo");

    if (!isJourneyAssist && !isJourneySolo) {
      this.props.history.push("/apps");
      return;
    }

    const workFlowPath = pathname;
    const appId = pathname.split("/")[3];

    try {
      // Fetch and update apps list
      const appResponse = await Http.get(`org/${orgId}/apps`).toPromise();
      this.props.updateAppsList?.(appResponse);

      // Fetch app details
      const appRes: any = await Http.get(`org/${orgId}/apps/${appId}`).toPromise();

      if (_.size(appRes) === 0) {
        console.warn(`No app details found for appId: ${appId}`);
        return;
      }

      const branchId = appRes[0]?.branches?.[0]?.["f1"];
      const branchName = appRes[0]?.branches?.[0]?.["f2"];

      // Fetch versions for this branch
      const versions: any = await Http.get(`versions/${appId}?branchId=${branchId}`).toPromise();
      const versionCode: any = _.maxBy(versions, "version_code");

      if (!versionCode) return;

      const versionIndex = _.findIndex(versions, versionCode);
      versions[versionIndex].currentVersion = true;
      const currentVersion = _.find(versions, ["currentVersion", true]);

      let previousVersionId = null;
      if (versions.length > 1) {
        const previousVersion = _.find(versions, ["version_code", versionCode?.version_code - 1]);
        previousVersionId = previousVersion?.version_id || null;
      }

      // Update version info
      this.props.updateAppVersion({
        key: appId,
        value: {
          appId,
          versionId: currentVersion.version_id,
          previousVersionId,
          currentVersion: true,
        },
      });

      // Update branch info
      this.props.updateAppBranch({
        key: appRes[0].appId,
        value: { branchName, branchId },
      });

      // Update organization info
      this.props.setCurrentOrganization({
        selectedOrg: { id: orgId, orgName, owner: ownerId },
      });

      // Navigate to workflow path
      this.props.history.push(workFlowPath);

    } catch (err) {
      console.error("Error fetching app details", err);
    }
  }

  render() {
    const [props] = [this.props];
    const { isAuthenticating, authError, xForgeToken } = this.state;
    
    // Show loading page while x-forge authentication is in progress
    if (isAuthenticating || xForgeToken) {
      return (
          <div style={{ position: "fixed", height: "100vh", width: '100%', inset: 0, background: "white", zIndex: 1000 }}>
            <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div className='authenticate_loader'>
                    <span className="authenticate_spin"></span>
                    <span>Authenticating...</span>
                </div>
            </div>
        </div>
      );
    }

    // If authentication failed, redirect to signin will be handled in componentDidMount
    if (authError) {
      return <Redirect to="/signin" />;
    }

    const topLevelRoutes = ["select-onboarding","home", "apps", "organization", "profile", "signin", "signup", "marketplace", "downloads", "404", "dmn"];
    const pathSegments = props.location.pathname.split("/").filter(el => el);
    const token = localStorage.getItem("studioToken");

    const redirectTo = new URLSearchParams(this.props.location.search).get("redirectTo")
    if(redirectTo && token && window.env.GENAI_URL && redirectTo === window.env.GENAI_URL) {
      return null
    }

    return (
      <React.Fragment>
        {props.path &&
          ((!token && ["/signin", "/signup"].includes(props.path)) ||
            (token && !["/signin", "/signup"].includes(props.path))) && topLevelRoutes.includes(pathSegments[0]) ? (
          <Route path={props.path} component={props.component} {...props} />
        ) : props.path && !token ? (
          <Redirect to="/signin" />
        ) : (
          <Redirect to={{ pathname: !pathSegments.length ? '/home' : '/404', state: props.location.state }} />
        )}
        {token ? (
          <Redirect
            to={{
              pathname: ["/signin", "/signup", "/"].includes(props.location.pathname) || !topLevelRoutes.includes(pathSegments[0])
                ? !pathSegments.length ? '/home' : '/404'
                : props.location.pathname,
              state: props.location.state
            }}
          />
        ) : props.location.pathname === "/signin/email-signIn" ? (
          <Redirect to={props.location.pathname} />
        ) : props.location.pathname === '/signup' ? (
          <Redirect to={"/signup"} />
        ) : (
          <Redirect to={"/signin"} />
        )}
      </React.Fragment>
    );
  }
}

function updatePath(location: any, props: ReactInstance) {
  props.deleteCurrentPath();
  const splitLocation = location.pathname.split("/");
  let setPath = "";
  splitLocation.forEach((name: string, index: number) => {
    setPath += name + "/";
    const locationArray: any = Object.values(PathsENUM);
    if (index > 0) {
      if (locationArray.includes(name)) {
        props.addCurrentPath({ name: name, link: setPath.replace(/.$/, "") });
      } else {
        props.addCurrentPath({ name: "", link: setPath.replace(/.$/, "") });
      }
    }
  });
}

export default connect(
  null,
  { addCurrentPath, updateCurrentPath, deleteCurrentPath, logout, setUser, saveDetails, updateAppBranch, updateAppVersion, setCurrentOrganization, updateAppsList }
)(withRouter(AuthRoute));